import React from 'react';
import { type Task, TaskStatus } from 'src/api/generated';
import { PiCheckCircle, PiCircle, PiXCircle } from 'react-icons/pi';

interface TaskStatusIconProps {
  task: Task;
  className?: string;
}

/**
 * Shared component for displaying task status icons
 */
export const TaskStatusIcon: React.FC<TaskStatusIconProps> = ({
  task,
  className = 'h-5 w-5',
}) => {
  if (task.status === TaskStatus.COMPLETED) {
    return <PiCheckCircle className={className} />;
  } else if (task.status === TaskStatus.CANCELLED) {
    return <PiXCircle className={className} />;
  } else {
    return <PiCircle className={className} />;
  }
};
